import { usePageOverlay } from '@/lib/pageOverlay'

export default function () {
  const drawerTriggers = document.querySelectorAll('[data-drawer]')
  const drawerClosers = document.querySelectorAll('[data-drawer-close]')

  function openDrawer(e: Event, drawerID: string) {
    e.preventDefault()
    const drawerToOpen = document.querySelector(`#${drawerID}`)
    drawerToOpen?.classList.add('Drawer--visible')
    drawerToOpen?.setAttribute('aria-hidden', 'false')
    show()
  }

  function closeDrawer(e: Event) {
    e.preventDefault()
    const drawersToClose = document.querySelectorAll(`.Drawer`)
    drawersToClose.forEach((d) => {
      d.classList.remove('Drawer--visible')
      d.setAttribute('aria-hidden', 'true')
    })
    hide()
  }

  const { show, hide } = usePageOverlay(
    (e) => {
      if (document.querySelector('.PageOverlay') === e.target) {
        closeDrawer(e)
      }
    },
    (e) => {
      if (e.key === 'Escape') {
        closeDrawer(e)
      }
    },
  )

  if (drawerTriggers && drawerClosers) {
    if (drawerTriggers.length >= 1) {
      drawerTriggers.forEach((drawerTrigger) => {
        const TriggerDrawerID = (drawerTrigger as HTMLElement).dataset
          .drawer as string
        drawerTrigger.addEventListener(
          'click',
          function (e) {
            openDrawer(e, TriggerDrawerID)
          },
          false,
        )
      })
    }

    if (drawerClosers.length >= 1) {
      drawerClosers.forEach((drawerClose) => {
        drawerClose.addEventListener(
          'click',
          function (e) {
            closeDrawer(e)
          },
          false,
        )
      })
    }
  }
}
